import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { LoaderComponent } from '../../../common-component/loader/loader.component';
import { SettlementServiceService } from '../../../services/raintree/Transmission/settlement-service.service';
import { CommonUtilService } from '../../../services/common-util/common-util.service';
import { SearchService } from '../../../services/common/search.service';
import { BillDetailsComponent } from '../mandir-bill/bill-details/bill-details.component';
import { ViewAdvanceDetailsComponent } from '../mandir-bill/view-advance-details/view-advance-details.component';
import * as XLSX from 'xlsx';
import saveAs from 'file-saver';

@Component({
  selector: 'app-mandir-bill-view',
  standalone: true,
  imports: [
    LoaderComponent,
    CommonModule,
    MatIconModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
  ],
  templateUrl: './mandir-bill-view.component.html',
  styleUrls: ['./mandir-bill-view.component.scss', '../../../../styles/_dropdown.scss'],
})
export class MandirBillViewComponent implements OnInit {
  breadcrumbs: string[] = ['INDIA'];
  selectedState = '';
  selectedDistrict = '';
  isLoading = false;
  rawStats: any[] = [];
  tableData: any[] = [];
  searchTerm = new FormControl('')
  public isMobileDevice: boolean = false;
  updatedData: any[] = [];
  tempUpdatedData: any[] = [];
  displayColumnData: any[] = [];
  isCardOpen: boolean = false;
  allowedKeys: any[] = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete'];

  fyList = this.buildFYList();
  currentFY = new FormControl(this.getCurrentFY());

  amountRangeForm = new FormGroup({
    minAmount: new FormControl('', [
      Validators.pattern(/^[1-9][0-9]*$/),
      Validators.required
    ]),
    maxAmount: new FormControl('', [
      Validators.pattern(/^[1-9][0-9]*$/),
      Validators.required
    ]),
  });

  constructor(
    private settlementService: SettlementServiceService,
    private toastr: ToastrService,
    private isMobile: CommonUtilService,
    private _searchService: SearchService,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.loadStats();
    this.currentFY.valueChanges.subscribe(() => {
      this.selectedState = '';
      this.breadcrumbs = ['INDIA'];
      this.loadStats();
    });
    this.isMobileDevice = this.isMobile.isMobileDevice();
    this.searchTerm
      ?.valueChanges.subscribe((value: any) => {
        this.updatedData = this.tempUpdatedData;
        if (value?.length >= 1) {
          this.updatedData = this._searchService.filterData(
            this.updatedData,
            value,
            this.displayColumnData
          );
        } else this.updatedData = this.tempUpdatedData;
      });
  }

  buildFYList(): { key: string; label: string }[] {
    const list: { key: string; label: string }[] = [];
    const baseYear = new Date().getFullYear() + 1;
    for (let y = baseYear; y >= baseYear - 7; y--) {
      list.push({ key: String(y - 1), label: `${y - 1}-${String(y).slice(-2)}` });
    }
    return list;
  }
   
  
  getCurrentFY(): string {
    const now = new Date();
    return now.getMonth() >= 3 ? String(now.getFullYear()) : String(now.getFullYear() - 1);
  }

  restrictAmountInput(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;

    if (this.allowedKeys.includes(event.key) || event.ctrlKey || event.altKey || event.metaKey) return;

    if (!/\d$/.test(event.key)) {
      event.preventDefault();
      return;
    }
    const future = input.value.slice(0, input.selectionStart!) + event.key + input.value.slice(input.selectionEnd!);
    if (/^0/.test(future) || future.length > 12) {
    event.preventDefault();
  }
  }

  openFilterCard() {
    this.isCardOpen = true;
  }
  resetFilter() {
    this.amountRangeForm.reset();
    this.amountRangeForm.controls.maxAmount.setValue('');
    this.amountRangeForm.controls.minAmount.setValue('');
  }
  closeFilterCard() {
    this.isCardOpen = false;
  }

  applyFilter() {
    console.log("apply filter called ")
    this.isLoading = true;
    this.isCardOpen = false;

    // const min =Number (this.amountRangeForm.get('minAmount')?.value);
    // const max = Number(this.amountRangeForm.get('maxAmount')?.value);
    const min =this.amountRangeForm.get('minAmount')?.value;
    const max = this.amountRangeForm.get('maxAmount')?.value;

    // if (this.selectedState && this.selectedDistrict && !min && !max) {
    //   this.settlementService.getUnsettledMandir({
    //     pageno: 1,
    //     fy: this.currentFY.value,
    //     uiState: this.selectedState,
    //     uiDistrict: this.selectedDistrict,
    //   }).subscribe({
    //     next: (res) => {
    //       this.isLoading = false;
    //       this.rawStats = res.data || [];
    //       this.buildTableData();
    //     },
    //     error: (err) => {
    //       this.isLoading = false;
    //       this.toastr.error(err?.message || 'Failed to load mandir details');
    //     },
    //   });
    //   return;
    // }

    // if (!min) {
    //   this.toastr.error("Please enter minimum amount");
    //   this.isLoading = false;
    //   return;
    // }
    // if (!max) {
    //   this.toastr.error("Please enter maximum amount");
    //   this.isLoading = false;
    //   return;
    // }
    // if (min > max) {
    //   this.toastr.error("Max amount should be greater than min amount");
    //   this.isLoading = false;
    //   return;
    // }


    if (this.selectedState && this.selectedDistrict) {
      this.settlementService.getUnsettledMandir({
        pageno: 1,
        fy: this.currentFY.value,
        uiState: this.selectedState,
        uiDistrict: this.selectedDistrict,
        minAmount: min,
        maxAmount: max,
      }).subscribe({
        next: (res) => {
          this.isLoading = false;
          this.rawStats = res.data || [];
          this.buildTableData();
        },
        error: (err) => {
          this.isLoading = false;
          this.toastr.error(err?.message || 'Failed to load mandir details');
        },
      });
      return;
    }
  }

  loadStats() {
    console.log("load state api called ")
    this.isLoading = true;

    if (this.selectedState && this.selectedDistrict) {
      this.settlementService.getUnsettledMandir({
        pageno: 1,
        fy: this.currentFY.value,
        uiState: this.selectedState,
        uiDistrict: this.selectedDistrict,
      }).subscribe({
        next: (res) => {
          this.isLoading = false;
          this.rawStats = res.data || [];
          this.buildTableData();
        },
        error: (err) => {
          this.isLoading = false;
          this.toastr.error(err?.message || 'Failed to load mandir details');
        },
      });
      return;
    }

    const params: any = { fy: this.currentFY.value };
    if (this.selectedState) params.uiState = this.selectedState;

    this.settlementService.getMandirSettlementStats(params).subscribe({
      next: (res) => {
        this.isLoading = false;
        this.rawStats = res.data || [];
        this.buildTableData();
      },
      error: (err) => {
        this.isLoading = false;
        this.toastr.error(err?.message || 'Failed to load data');
      },
    });
  }

  buildTableData() {
    if (!this.selectedState) {

      const map = new Map<string, any>();
      for (const d of this.rawStats) {
        const prev = map.get(d.state_name) ?? {
          total_mandirs: 0,
          total_advance: 0,
          remaining_amount: 0
        };

        map.set(d.state_name, {
          total_mandirs: prev.total_mandirs + Number(d.total_mandirs),
          total_advance: prev.total_advance + Number(d.total_advance),
          remaining_amount: prev.remaining_amount + Number(d.remaining_amount),
        });
      }

      this.tableData = Array.from(map.entries()).map(([state_name, v]) => ({
        state_name,
        ...v
      }));

      this.displayColumnData = [
        { id: 'state_name', name: 'State' },
        { id: 'total_mandirs', name: 'Total Mandirs' }
      ];

    } else if (this.selectedState && !this.selectedDistrict) {

      this.tableData = this.rawStats.map((d) => ({
        state_name: d.state_name,
        district_name: d.district_name,
        total_mandirs: Number(d.total_mandirs),
      }));

      this.displayColumnData = [
        { id: 'state_name', name: 'State' },
        { id: 'district_name', name: 'District' },
        { id: 'total_mandirs', name: 'Total Mandirs' }
      ];
    }

    else {
      this.tableData = this.rawStats.map((d) => ({
        scoa_name: d.scoa_name,
        scoa_code: d.scoa_code,
        last_advance_date: d.last_advance_date,
        last_bill_receive_date: d.last_bill_receive_date,
        total_advance_given: Number(d.total_advance_given),
        total_bill_payment: Number(d.total_bill_payment),
        remaining_amount: Number(d.remaining_amount),
      }));

      this.displayColumnData = [
        { id: 'scoa_name', name: 'Mandir Name' },
        { id: 'scoa_code', name: 'Code' },
        { id: 'last_advance_date', name: 'Last Advance Date' },
        { id: 'last_bill_receive_date', name: 'Last Bill Date' },
        { id: 'total_advance_given', name: 'Advance Taken' },
        { id: 'total_bill_payment', name: 'Bill Provided' },
        { id: 'remaining_amount', name: 'Unsettled' }
      ];
    }

    this.tempUpdatedData = [...this.tableData];
    this.updatedData = [...this.tableData];
  }

  onClickDistrict(row: any) {
    this.selectedDistrict = row.district_name;

    this.breadcrumbs = ['INDIA', row.state_name, row.district_name];

    this.loadStats();
  }

  onClickState(state: string) {
    this.selectedState = state;
    this.breadcrumbs = ['INDIA', state];
    this.loadStats();
  }

  onClickBreadcrumb(crumb: string) {
    const index = this.breadcrumbs.indexOf(crumb);
    if (index === -1) return;

    this.breadcrumbs = this.breadcrumbs.slice(0, index + 1);

    if (this.breadcrumbs.length === 1) {
      this.selectedState = '';
      this.selectedDistrict = '';
    }
    else if (this.breadcrumbs.length === 2) {
      this.selectedDistrict = '';
    }

    this.loadStats();
  }

  openAdvanceDetails(row: any) {
    this.dialog.open(ViewAdvanceDetailsComponent, {
      width: '70vw',
      panelClass: 'custom-dialog-container',
      data: {
        mandirCode: row.scoa_code,
        fy: this.currentFY.value || '',
      },
    });
  }

  openBillDetails(row: any) {
    this.dialog.open(BillDetailsComponent, {
      width: '70vw',
      panelClass: 'custom-dialog-container',
      data: {
        mandirCode: row.scoa_code,
        fy: this.currentFY.value || '',
      },
    });
  }

  isValidAmount(value: any): boolean {
    return value !== null && value !== undefined && !isNaN(value) && Number(value) !== 0;
  }

  fmt(amount: number): string {
    if (!amount) return '₹ --.--';
    return '₹ ' + amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  exportExcelData() {
    // console.log(this.rawStats,'EXPORT DATA', this.updatedData)
    const excelData = this.updatedData.map((item: any) => ({
      'Mandir Name': item.scoa_name,
      'Mandir Code': item.scoa_code,
      'Last Advance Date': item.last_advance_date,
      'Last Bill Date': item.last_bill_receive_date,
      'Advance Amount': item.total_advance_given,
      'Bill Submitted': item.total_bill_payment,
      'Unsettled Amount':item.remaining_amount,
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Mandir Bill': worksheet },
      SheetNames: ['Mandir Bill']
    };

    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });

    this.saveExcelFile(excelBuffer, `Mandir_Bills_${this.rawStats[0]?.state_name}_${this.rawStats[0]?.district_name}`);
  }

  saveExcelFile(buffer: any, fileName: string) {
      const data: Blob = new Blob([buffer], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
  
      saveAs(data, `${fileName}_${new Date().getTime()}.xlsx`);
    }

}
